import { call, put, takeLatest, type PayloadAction } from '@ufc/core'

import type { DriverMilestone, LiveTripsResponse } from '../domain/types/api.types'
import { tripPlanningApi } from '../infrastructure/api/trip-planning-api'
import { tripPlanningLiveActions } from './live.slice'

function* loadLiveTrips(action: PayloadAction<string>) {
  try {
    const result: LiveTripsResponse = yield call(tripPlanningApi.live, action.payload)
    yield put(tripPlanningLiveActions.loadSuccess(result))
  } catch (cause) {
    const message = cause instanceof Error ? cause.message : 'Could not load live trips'
    yield put(tripPlanningLiveActions.loadFailure(message))
  }
}

function* confirmArrival(
  action: PayloadAction<{ referenceId: string; planDate: string }>,
) {
  try {
    yield call(tripPlanningApi.confirmArrival, action.payload.referenceId, action.payload.planDate)
    yield put(tripPlanningLiveActions.confirmArrivalSuccess())
    yield put(tripPlanningLiveActions.load(action.payload.planDate))
  } catch (cause) {
    const message = cause instanceof Error ? cause.message : 'Could not confirm arrival'
    yield put(tripPlanningLiveActions.confirmArrivalFailure(message))
  }
}

function* confirmMilestone(
  action: PayloadAction<{ referenceId: string; planDate: string; milestone: DriverMilestone }>,
) {
  try {
    yield call(
      tripPlanningApi.recordDriverMilestone,
      action.payload.referenceId,
      action.payload.planDate,
      action.payload.milestone,
    )
    yield put(tripPlanningLiveActions.confirmMilestoneSuccess())
    yield put(tripPlanningLiveActions.load(action.payload.planDate))
  } catch (cause) {
    const message = cause instanceof Error ? cause.message : 'Could not record milestone'
    yield put(tripPlanningLiveActions.confirmMilestoneFailure(message))
  }
}

export function* tripPlanningLiveSaga() {
  yield takeLatest(tripPlanningLiveActions.load.type, loadLiveTrips)
  yield takeLatest(tripPlanningLiveActions.confirmArrival.type, confirmArrival)
  yield takeLatest(tripPlanningLiveActions.confirmMilestone.type, confirmMilestone)
}
